import styled from 'styled-components';

export const ResultsSearchBarStyle = styled.div`
    /* width: 35%;
    display: flex;
    align-items: center;
    border: none;
    border-radius: 1px solid grey;
    padding-left: 14px;
    gap: 10px;
    border-radius: 20px;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
    .search-bar{
        width: 80%;
        height: 35px;
        outline: none;
        padding: 5px;
        border: none;
        font-size: medium;
    }
    .search-icon{
        font-size: 20px;
        color: darkslategrey;
    } */
`;